import script from "./CollaboratorItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CollaboratorItem.vue?vue&type=script&setup=true&lang=js"

import "./CollaboratorItem.vue?vue&type=style&index=0&id=37415896&lang=scss"
import "./CollaboratorItem.vue?vue&type=style&index=1&id=37415896&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37415896"]])

export default __exports__